<template>
    <DModal
        :title="__('customers.contracts.move_zone.modal.title')"
        :message="__('customers.contracts.move_zone.modal.message', {brand: oneHopBrand})"
        is-confirm
        is-error
        :is-awaiting-validation="true"
        @confirm="confirmForm"
        @close="closeModal"
    >
        <div style="padding: 20px;">
            <DRow style="margin-bottom: 30px;">
                <DCol style="display: flex; align-items: center; gap: 1rem;">
                    <DSwitch
                        v-model="form.takeoverZoneConfig"
                        :invalid-feedback="errorsData.takeoverZoneConfig"
                        color="success"
                        variant="3d"
                    />
                    <label style="margin-bottom: 0;">{{ __('customers.contracts.move_zone.modal.switch_text') }}</label>
                </DCol>
            </DRow>
        </div>
    </DModal>
</template>

<script setup>
import { useForm } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'
import { ref } from 'vue'

const props = defineProps({
    contract: {
        type: Object,
        default: () => { return {} }
    },
    oneHopBrand: {
        type: String,
        default: null
    },
    showModal: {
        type: Boolean,
        default: false
    },
    errors: {
        type: Object,
        default: () => { return {} }
    }
})

const errorsData = ref(props.errors)

const form = useForm({
    takeoverZoneConfig: false
})

const emit = defineEmits(['close-modal'])

const closeModal = () => {
    form.takeoverZoneConfig = false
    emit('close-modal')
}

const confirmForm = () => {
    form.post(route('customers.customers.contracts.move-zone', {
        customer: props.contract.customer_id,
        contract: props.contract.id
    }), {
        onSuccess: () => {
            emit('close-modal')
        },
        onError: (error) => {
            errorsData.value = error
        }
    })
}
</script>

<style scoped lang="scss">

</style>
